
  import {createControllersWithDescriptors, initAppForPageWrapper} from '@wix/yoshi-flow-editor/runtime/esm/viewerScript/wrapper.js';
  
  
            
import wrapController0 from '@wix/yoshi-flow-editor-runtime/internal/viewerScript/blocks';

            import controller0 from '/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/Above content 1/viewer.controller.ts';
            import * as _controllerExport0 from '/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/Above content 1/model.ts';
            var controllerExport0 = _controllerExport0;
            

            
import wrapController1 from '@wix/yoshi-flow-editor-runtime/internal/viewerScript/blocks';

            import controller1 from '/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/Above content 2/viewer.controller.ts';
            import * as _controllerExport1 from '/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/Above content 2/model.ts';
            var controllerExport1 = _controllerExport1;
            

            
import wrapController2 from '@wix/yoshi-flow-editor-runtime/internal/viewerScript/ooi';

            import controller2 from '/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/Archive/controller.ts';
            import * as _controllerExport2 from '/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/Archive/controller.ts';
            var controllerExport2 = _controllerExport2;
            

            
import wrapController3 from '@wix/yoshi-flow-editor-runtime/internal/viewerScript/blocks';

            import controller3 from '/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/Below content 1/viewer.controller.ts';
            import * as _controllerExport3 from '/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/Below content 1/model.ts';
            var controllerExport3 = _controllerExport3;
            

            
import wrapController4 from '@wix/yoshi-flow-editor-runtime/internal/viewerScript/blocks';

            import controller4 from '/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/Below content 2/viewer.controller.ts';
            import * as _controllerExport4 from '/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/Below content 2/model.ts';
            var controllerExport4 = _controllerExport4;
            

            
import wrapController5 from '@wix/yoshi-flow-editor-runtime/internal/viewerScript/ooi';

            import controller5 from '/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/Blog/controller.ts';
            import * as _controllerExport5 from '/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/Blog/controller.ts';
            var controllerExport5 = _controllerExport5;
            

            
import wrapController6 from '@wix/yoshi-flow-editor-runtime/internal/viewerScript/blocks';

            import controller6 from '/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/Bottom Of Page 1/viewer.controller.ts';
            import * as _controllerExport6 from '/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/Bottom Of Page 1/model.ts';
            var controllerExport6 = _controllerExport6;
            

            
import wrapController7 from '@wix/yoshi-flow-editor-runtime/internal/viewerScript/blocks';

            import controller7 from '/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/Bottom Of Page 2/viewer.controller.ts';
            import * as _controllerExport7 from '/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/Bottom Of Page 2/model.ts';
            var controllerExport7 = _controllerExport7;
            

            
import wrapController8 from '@wix/yoshi-flow-editor-runtime/internal/viewerScript/blocks';

            import controller8 from '/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/Bottom of Page 3/viewer.controller.ts';
            import * as _controllerExport8 from '/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/Bottom of Page 3/model.ts';
            var controllerExport8 = _controllerExport8;
            

            
import wrapController9 from '@wix/yoshi-flow-editor-runtime/internal/viewerScript/ooi';

            import controller9 from '/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/CategoryMenu/controller.ts';
            import * as _controllerExport9 from '/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/CategoryMenu/controller.ts';
            var controllerExport9 = _controllerExport9;
            

            
import wrapController10 from '@wix/yoshi-flow-editor-runtime/internal/viewerScript/ooi';

            import controller10 from '/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/MyPosts/controller.ts';
            import * as _controllerExport10 from '/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/MyPosts/controller.ts';
            var controllerExport10 = _controllerExport10;
            

            
import wrapController11 from '@wix/yoshi-flow-editor-runtime/internal/viewerScript/ooi';

            import controller11 from '/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/Post/controller.ts';
            import * as _controllerExport11 from '/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/Post/controller.ts';
            var controllerExport11 = _controllerExport11;
            

            
import wrapController12 from '@wix/yoshi-flow-editor-runtime/internal/viewerScript/blocks';

            import controller12 from '/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/Post Categories/viewer.controller.ts';
            import * as _controllerExport12 from '/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/Post Categories/model.ts';
            var controllerExport12 = _controllerExport12;
            

            
import wrapController13 from '@wix/yoshi-flow-editor-runtime/internal/viewerScript/blocks';

            import controller13 from '/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/Post Content/viewer.controller.ts';
            import * as _controllerExport13 from '/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/Post Content/model.ts';
            var controllerExport13 = _controllerExport13;
            

            
import wrapController14 from '@wix/yoshi-flow-editor-runtime/internal/viewerScript/blocks';

            import controller14 from '/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/Post Counters New/viewer.controller.ts';
            import * as _controllerExport14 from '/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/Post Counters New/model.ts';
            var controllerExport14 = _controllerExport14;
            

            
import wrapController15 from '@wix/yoshi-flow-editor-runtime/internal/viewerScript/blocks';

            import controller15 from '/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/Post Divider/viewer.controller.ts';
            import * as _controllerExport15 from '/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/Post Divider/model.ts';
            var controllerExport15 = _controllerExport15;
            

            
import wrapController16 from '@wix/yoshi-flow-editor-runtime/internal/viewerScript/blocks';

            import controller16 from '/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/Post Footer/viewer.controller.ts';
            import * as _controllerExport16 from '/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/Post Footer/model.ts';
            var controllerExport16 = _controllerExport16;
            

            
import wrapController17 from '@wix/yoshi-flow-editor-runtime/internal/viewerScript/blocks';

            import controller17 from '/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/Post Header/viewer.controller.ts';
            import * as _controllerExport17 from '/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/Post Header/model.ts';
            var controllerExport17 = _controllerExport17;
            

            
import wrapController18 from '@wix/yoshi-flow-editor-runtime/internal/viewerScript/blocks';

            import controller18 from '/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/Post Metadata/viewer.controller.ts';
            import * as _controllerExport18 from '/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/Post Metadata/model.ts';
            var controllerExport18 = _controllerExport18;
            

            
import wrapController19 from '@wix/yoshi-flow-editor-runtime/internal/viewerScript/blocks';

            import controller19 from '/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/Post Page/viewer.controller.ts';
            import * as _controllerExport19 from '/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/Post Page/model.ts';
            var controllerExport19 = _controllerExport19;
            

            
import wrapController20 from '@wix/yoshi-flow-editor-runtime/internal/viewerScript/blocks';

            import controller20 from '/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/Post Ratings/viewer.controller.ts';
            import * as _controllerExport20 from '/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/Post Ratings/model.ts';
            var controllerExport20 = _controllerExport20;
            

            
import wrapController21 from '@wix/yoshi-flow-editor-runtime/internal/viewerScript/blocks';

            import controller21 from '/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/Post Share Buttons/viewer.controller.ts';
            import * as _controllerExport21 from '/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/Post Share Buttons/model.ts';
            var controllerExport21 = _controllerExport21;
            

            
import wrapController22 from '@wix/yoshi-flow-editor-runtime/internal/viewerScript/blocks';

            import controller22 from '/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/Post Tags/viewer.controller.ts';
            import * as _controllerExport22 from '/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/Post Tags/model.ts';
            var controllerExport22 = _controllerExport22;
            

            
import wrapController23 from '@wix/yoshi-flow-editor-runtime/internal/viewerScript/blocks';

            import controller23 from '/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/Post Title/viewer.controller.ts';
            import * as _controllerExport23 from '/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/Post Title/model.ts';
            var controllerExport23 = _controllerExport23;
            

            
import wrapController24 from '@wix/yoshi-flow-editor-runtime/internal/viewerScript/blocks';

            import controller24 from '/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/Post Writer/viewer.controller.ts';
            import * as _controllerExport24 from '/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/Post Writer/model.ts';
            var controllerExport24 = _controllerExport24;
            

            
import wrapController25 from '@wix/yoshi-flow-editor-runtime/internal/viewerScript/ooi';

            import controller25 from '/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/PostList/controller.ts';
            import * as _controllerExport25 from '/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/PostList/controller.ts';
            var controllerExport25 = _controllerExport25;
            

            
import wrapController26 from '@wix/yoshi-flow-editor-runtime/internal/viewerScript/ooi';

            import controller26 from '/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/RelatedPosts/controller.ts';
            import * as _controllerExport26 from '/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/RelatedPosts/controller.ts';
            var controllerExport26 = _controllerExport26;
            

            
import wrapController27 from '@wix/yoshi-flow-editor-runtime/internal/viewerScript/ooi';

            import controller27 from '/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/RssButton/controller.ts';
            import * as _controllerExport27 from '/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/RssButton/controller.ts';
            var controllerExport27 = _controllerExport27;
            

            
import wrapController28 from '@wix/yoshi-flow-editor-runtime/internal/viewerScript/ooi';

            import controller28 from '/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/TagCloud/controller.ts';
            import * as _controllerExport28 from '/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/TagCloud/controller.ts';
            var controllerExport28 = _controllerExport28;
            

            
import wrapController29 from '@wix/yoshi-flow-editor-runtime/internal/viewerScript/blocks';

            import controller29 from '/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/Top of Page/viewer.controller.ts';
            import * as _controllerExport29 from '/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/Top of Page/model.ts';
            var controllerExport29 = _controllerExport29;
            

  
  import * as viewerApp from '/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/viewer.app.ts';
    var importedApp = viewerApp;


  

    var velocycleMobx = null;
    


  

    import { blocksControllerService } from '@wix/yoshi-flow-editor/runtime/esm/blocks/controllerService'
    

  
var createHttpClient = null;

  

  import { initI18n as initI18n } from '@wix/yoshi-flow-editor/runtime/esm/i18next/init';


  
const multilingualDisabled = false;

  

    var createExperiments = null;
    var createWidgetExperiments = null;
    


  var sentryConfig = {
      DSN: 'https://2062d0a4929b45348643784b5cb39c36@sentry.wixpress.com/1643',
      id: '2062d0a4929b45348643784b5cb39c36',
      projectName: 'communities-blog-ooi',
      teamName: 'blogas',
      errorMonitor: true,
    };

  var experimentsConfig = {"centralized":true,"scopes":["wix-social-blog","ricos"]};

  var translationsConfig = {"enabled":true,"icuEnabled":true,"defaultTranslationsPath":"/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/assets/locales/messages_en.json","availableLanguages":["ar","bg","ca","cs","da","de","el","en","es","fi","fr","he","hi","hr","hu","id","it","ja","ko","lt","lv","ms","nl","no","pl","pt","ro","ru","sk","sl","sv","th","tl","tr","uk","vi","zh"]};

  var defaultTranslations = {"app-manifest.page-info":"Page Info","app-manifest.layout":"Layout","app-manifest.layouts":"Layout","app-manifest.design":"Design","app-manifest.permissions":"Permissions","app-manifest.seo":"SEO Basics","app-manifest.blog-pages":"Blog Pages","app-manifest.manage-posts":"Manage Posts","app-manifest.delete-page":"Delete","app-manifest.delete-blog":"Delete Blog","app-manifest.settings":"Settings","app-manifest.widget-settings":"Widget settings","app-manifest.post-page-label":"Post","app-manifest.post-list":"Post List","app-manifest.post-ticker":"Post Ticker","app-manifest.category-list":"Categories","app-manifest.archive-list":"Archive","app-manifest.app-descriptor.post-settings-title":"Post","app-manifest.app-descriptor.create-post":"Create Post","app-manifest.app-descriptor.manage-posts":"Manage Blog","app-manifest.app-descriptor.manage-blog-pages":"Manage Blog Pages","app-manifest.app-descriptor.open-page-settings":"Customize Post Page","app-manifest.app-descriptor.add-blog-elements":"Add Blog Elements","app-manifest.app-descriptor.read-blogging-guide":"Read the Blogging Guide","member-pages.origin":"By Wix Blog","member-pages.posts.name":"Blog Posts","member-pages.posts.short-description":"Display members’ posts in one place","member-pages.posts.description.text":"Members can write and display their own blog posts to any visitors on the site.","member-pages.posts.description.bullet-point-1":"See all published posts","member-pages.posts.description.bullet-point-2":"Create a new post","member-pages.posts.description.bullet-point-3":"Scan for likes and comments on posts","member-pages.posts.description.bullet-point-4":"Keep track of the most popular posts","member-pages.drafts.name":"My Drafts","member-pages.drafts.short-description":"Let members create and manage their own blog drafts","member-pages.drafts.description.text":"On this private page, members can freely:","member-pages.drafts.description.bullet-point-1":"Create and edit drafts","member-pages.drafts.description.bullet-point-2":"Save drafts and come back to them later","member-pages.drafts.description.bullet-point-3":"Delete rejected drafts","member-pages.comments.name":"Blog Comments","member-pages.comments.short-description":"Display members' comments in one place","member-pages.comments.description.text":"Members can see comments they’ve made on the blog.","member-pages.comments.description.bullet-point-1":"Scan comments easily","member-pages.comments.description.bullet-point-2":"Engage in the discussion","member-pages.comments.description.bullet-point-3":"Discover the most popular comments and topics","member-pages.likes.name":"Blog Likes","member-pages.likes.short-description":"Display members' likes in one place","member-pages.likes.description.text":"Members can see all the posts they’ve liked on the blog.","member-pages.likes.description.bullet-point-1":"Scan likes easily","member-pages.likes.description.bullet-point-2":"Keep track of most liked posts","member-pages.followers.name":"Followers","member-pages.followers.short-description":"Let your members view and follow one another","member-pages.followers.description.text":"Allow members to see who’s following who in your community.","member-pages.followers.description.bullet-point-1":"View a list of your followers","member-pages.followers.description.bullet-point-2":"Follow or unfollow members from your list","member-pages.followers.description.bullet-point-3":"See who’s following other members of the community","member-pages.followers.description.bullet-point-4":"Manage members, set roles, assign badges, and more","member-pages.about.name":"Profile","member-pages.about.short-description":"Give your members their own personal profile","member-pages.about.description.text":"Members can customize their own profile that’ll express who they are to your online community.","member-pages.about.description.bullet-point-1":"Write something about yourself","member-pages.about.description.bullet-point-2":"Add images and video","member-pages.about.description.bullet-point-3":"View your community stats","member-pages.about.description.bullet-point-4":"View and assign badges","member-pages.about.description.bullet-point-5":"Share your profile","member-pages.about.origin":"By Wix Members","member-pages.followers.origin":"By Wix Members","installation-timeout.title":"Try installing Blog again","installation-timeout.description":"There was a technical issue with the app installation. Installing again shouldn’t take long.","installation-timeout.mainAction":"Try Again","installation-timeout.secondaryAction":"Delete App","post-page.displayName":"Post Page","post-page.gfpp.change-presets":"Change Presets","post-page.gfpp.manage-posts":"Manage Posts","post-page.panel.title":"Content","post-page.panel.notify-text":"This will affect all post page widgets.","post-page.panel.content-alignment":"Content alignment","post-page.panel.content-alignment.left":"Left","post-page.panel.content-alignment.center":"Center","post-page.panel.content-alignment.right":"Right","post-page.panel.content-width":"Content width","post-page.panel.padding":"Padding","post-page.panel.side-padding":"Side padding","post-page.panel.top-padding":"Top padding","post-page.panel.bottom-padding":"Bottom padding","post-header.gfpp.header-layout":"Header Layout","post-header.panel.title":"Header Layout","post-header.panel.choose-layout":"Choose a layout","post-header.panel.choose-layout.classic":"Classic","post-header.panel.choose-layout.stacked":"Stacked","post-header.panel.choose-layout.overlay":"Overlay","post-header.panel.content-title":"Content","post-header.panel.content-alignment":"Content alignment","post-header.panel.content-alignment.left":"Left","post-header.panel.content-alignment.center":"Center","post-header.panel.content-alignment.right":"Right","post-header.panel.content-width":"Content width","post-header.panel.content-side-padding":"Content side padding","post-header.panel.image":"Image","post-header.panel.image-position":"Image position","post-header.panel.image-position.top":"Top","post-header.panel.image-position.bottom":"Bottom","post-header.panel.image-resizing":"Image resizing","post-header.panel.image-resizing.fill":"Fill","post-header.panel.image-resizing.fit":"Fit","post-header.panel.image-height":"Image height","post-header.panel.padding":"Padding","post-header.panel.top-padding":"Top padding","post-header.panel.bottom-padding":"Bottom padding","post-metadata.gfpp.metadata-layout":"Metadata Layout","post-metadata.time-to-read.label":"{minutes, number} min read","post-metadata.update-date":"Updated: {date}","post-metadata.panel.title":"Metadata Layout","post-metadata.panel.choose-layout":"Choose a layout","post-metadata.panel.choose-layout.stacked":"Stacked","post-metadata.panel.choose-layout.inline":"Inline","post-metadata.panel.show-avatar":"Show avatar","post-metadata.panel.alignment":"Alignment","post-metadata.panel.alignment.left":"Left","post-metadata.panel.alignment.center":"Center","post-metadata.panel.alignment.right":"Right","post-metadata.panel.padding":"Padding","post-metadata.panel.top-padding":"Top padding","post-metadata.panel.side-padding":"Side padding","post-metadata.panel.bottom-padding":"Bottom padding","post-metadata.panel.spacing":"Spacing","post-metadata.panel.spacing.horizontal":"Horizontal spacing","post-metadata.panel.spacing.vertical":"Vertical spacing","post-categories.displayName":"Post Categories","post-categories.gfpp.categories-layout":"Categories Layout","post-categories.gfpp.settings":"Settings","post-categories.gfpp.button":"Categories Button","post-categories.panel.title":"Category Layout","post-categories.panel.categories-to-display":"Categories to display","post-categories.panel.categories-to-display.mainCategory":"Main category","post-categories.panel.categories-to-display.allCategories":"All assigned categories","post-categories.panel.choose-layout":"Choose a layout","post-categories.panel.choose-layout.text":"Text","post-categories.panel.choose-layout.button":"Button","post-categories.panel.alignment":"Alignment","post-categories.panel.alignment.left":"Left","post-categories.panel.alignment.center":"Center","post-categories.panel.alignment.right":"Right","post-categories.panel.direction":"Direction","post-categories.panel.direction.leftToRight":"Left to right","post-categories.panel.direction.rightToLeft":"Right to left","post-categories.panel.padding":"Padding","post-categories.panel.top-padding":"Top padding","post-categories.panel.bottom-padding":"Bottom padding","post-categories.panel.side-padding":"Side padding","post-tags.displayName":"Post Tags","post-tags.gfpp.tags-layout":"Tags Layout","post-tags.panel.title":"Tag Layout","post-tags.panel.choose-layout":"Choose a layout","post-tags.panel.choose-layout.text":"Text","post-tags.panel.choose-layout.button":"Button","post-tags.panel.alignment":"Alignment","post-tags.panel.alignment.left":"Left","post-tags.panel.alignment.center":"Center","post-tags.panel.alignment.right":"Right","post-tags.panel.direction":"Direction","post-tags.panel.direction.leftToRight":"Left to right","post-tags.panel.direction.rightToLeft":"Right to left","post-tags.panel.padding":"Padding","post-tags.panel.top-padding":"Top padding","post-tags.panel.bottom-padding":"Bottom padding","post-tags.panel.side-padding":"Side padding","post-title.displayName":"Post Title","post-title.gfpp.title-layout":"Title Layout","post-title.gfpp.edit-text":"Edit Text","post-title.panel.title":"Title Layout","post-title.panel.alignment":"Alignment","post-title.panel.alignment.left":"Left","post-title.panel.alignment.center":"Center","post-title.panel.alignment.right":"Right","post-title.panel.padding":"Padding","post-title.panel.top-padding":"Top padding","post-title.panel.bottom-padding":"Bottom padding","post-writer.displayName":"Post Writer","post-writer.gfpp.writer-layout":"Writer Layout","post-ratings.displayName":"Post Ratings","post-ratings.gfpp.ratings-layout":"Ratings Layout","post-ratings.panel.title":"Ratings Layout","post-ratings.panel.alignment":"Alignment","post-ratings.panel.alignment.left":"Left","post-ratings.panel.alignment.center":"Center","post-ratings.panel.alignment.right":"Right","post-ratings.panel.padding":"Padding","post-ratings.panel.top-padding":"Top padding","post-ratings.panel.bottom-padding":"Bottom padding","post-divider.displayName":"Post Divider","post-divider.gfpp.divider-layout":"Divider Layout","post-divider.panel.title":"Divider Layout","post-share-buttons.displayName":"Share Buttons","post-share-buttons.gfpp.share-buttons-layout":"Share Buttons Layout","post-share-buttons.panel.title":"Share Buttons Layout","post-share-buttons.panel.alignment":"Alignment","post-share-buttons.panel.alignment.left":"Left","post-share-buttons.panel.alignment.center":"Center","post-share-buttons.panel.alignment.right":"Right","post-share-buttons.panel.alignment.horizontal":"Horizontal","post-share-buttons.panel.alignment.vertical":"Vertical","post-share-buttons.panel.display-options":"Choose what displays","post-share-buttons.panel.display-options.icon-only":"Icon only","post-share-buttons.panel.display-options.text-only":"Text only","post-share-buttons.panel.display-options.text-and-icon":"Text and icon","post-counters.gfpp.counters-layout":"Counters Layout","post-counters.panel.title":"Counters Layout","post-counters.panel.icon-size":"Icon Size","post-counters.panel.alignment":"Alignment","post-counters.panel.alignment.left":"Left","post-counters.panel.alignment.center":"Center","post-counters.panel.alignment.right":"Right","post-counters.panel.padding":"Padding","post-counters.panel.top-padding":"Top padding","post-counters.panel.bottom-padding":"Bottom padding","post-footer.displayName":"Post Footer","post-footer.gfpp.footer-layout":"Footer Layout","post-footer.panel.title":"Footer Layout","post-footer.panel.alignment":"Alignment","post-footer.panel.alignment.left":"Left","post-footer.panel.alignment.center":"Center","post-footer.panel.alignment.right":"Right","post-footer.panel.content-width":"Content width","post-footer.panel.padding":"Padding","post-footer.panel.top-padding":"Top padding","post-footer.panel.bottom-padding":"Bottom padding","post-content.displayName":"Post Content","post-content.gffp.content-layout":"Content Layout","post-content.panel.title":"Content Layout","post-content.panel.padding":"Padding","post-content.panel.top-padding":"Top padding","post-content.panel.bottom-padding":"Bottom padding","post-slot-widget.gfpp.layout":"Layout","post-top-of-page.displayName":"Top of Page","post-above-content-1.displayName":"Above content 1","post-above-content-2.displayName":"Above content 2","post-below-content-1.displayName":"Below content 1","post-below-content-2.displayName":"Below content 2","post-below-content-3.displayName":"Below content 3","post-bottom-of-page-1.displayName":"Bottom of Page 1","post-bottom-of-page-2.displayName":"Bottom of Page 2","post-bottom-of-page-3.displayName":"Bottom of Page 3","post.elements.categories":"Categories","post.elements.tags":"Tags","post.elements.writer":"Writer","post.elements.counters":"Counters","post.elements.title":"Title","post.elements.ratings":"Ratings","post.elements.likes":"Likes","post.elements.views":"Views","post.elements.comments":"Comments","post.elements.publish-date":"Publish date","post.elements.reading-time":"Reading time","post.elements.last-updated":"Last updated","post.elements.divider":"Divider","post.elements.main-elements":"Main elements","post.elements.metadata":"Metadata","post.elements.decorative":"Decorative","post.elements.header":"Header","post.elements.content":"Content","post.elements.footer":"Footer","post.elements.related-posts":"Related posts","post.views.count":"{count, plural, =1 {1 view} other {{count} views}}","post.comments.count":"{count, plural, =1 {1 comment} other {{count} comments}}","post.likes.count":"{count, plural, =1 {1 like} other {{count} likes}}"};

  var fedopsConfig = null;

  import { createVisitorBILogger as biLogger } from '/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/target/generated/bi/createBILogger.ts';

  export const exports = importedApp.exports;

  export const initAppForPage = initAppForPageWrapper({
    initAppForPage: importedApp.initAppForPage,
    sentryConfig: sentryConfig,
    experimentsConfig: experimentsConfig,
    inEditor: false,
    biLogger: biLogger,
    multilingualDisabled,
    projectName: "communities-blog-ooi",
    biConfig: null,
    appName: "Wix Blog",
    appDefinitionId: "14bcded7-0066-7c35-14d7-466cb3f09103",
    fedopsConfig: fedopsConfig,
    translationsConfig: translationsConfig,
    defaultTranslations: defaultTranslations,
    shouldUseEssentials: true,
    optionalDeps: {
      initI18n,
      createHttpClient,
      createExperiments,
    },
    localeDistPath: "assets/locales",
  });

  const _createControllers = createControllersWithDescriptors({
    initI18n,
    blocksControllerService,
    createHttpClient,
    createExperiments,
    velocycleMobx,
  }, [{ method: controller0,
          wrap: wrapController0,
          exports: controllerExport0,
          widgetType: "BLOCKS_WIDGET",
          translationsConfig,
          multilingualDisabled,
          experimentsConfig: {"centralized":true,"scopes":["wix-social-blog","ricos"]},
          fedopsConfig: fedopsConfig,
          sentryConfig: sentryConfig,
          persistentAcrossPages: false,
          biLogger: biLogger,
          shouldUseEssentials: true,
          withErrorBoundary: false,
          biConfig: null,
          controllerFileName: "/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/Above content 1/viewer.controller.ts",
          appName: "Wix Blog",
          appDefinitionId: "14bcded7-0066-7c35-14d7-466cb3f09103",
          projectName: "communities-blog-ooi",
          componentName: "Above content 1",
          localeDistPath: "assets/locales",
          defaultTranslations: defaultTranslations,
          id: "14bcded7-0066-7c35-14d7-466cb3f09103-eii64" }, { method: controller1,
          wrap: wrapController1,
          exports: controllerExport1,
          widgetType: "BLOCKS_WIDGET",
          translationsConfig,
          multilingualDisabled,
          experimentsConfig: {"centralized":true,"scopes":["wix-social-blog","ricos"]},
          fedopsConfig: fedopsConfig,
          sentryConfig: sentryConfig,
          persistentAcrossPages: false,
          biLogger: biLogger,
          shouldUseEssentials: true,
          withErrorBoundary: false,
          biConfig: null,
          controllerFileName: "/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/Above content 2/viewer.controller.ts",
          appName: "Wix Blog",
          appDefinitionId: "14bcded7-0066-7c35-14d7-466cb3f09103",
          projectName: "communities-blog-ooi",
          componentName: "Above content 2",
          localeDistPath: "assets/locales",
          defaultTranslations: defaultTranslations,
          id: "14bcded7-0066-7c35-14d7-466cb3f09103-prihd" }, { method: controller2,
          wrap: wrapController2,
          exports: controllerExport2,
          widgetType: "WIDGET_OUT_OF_IFRAME",
          translationsConfig,
          multilingualDisabled,
          experimentsConfig: {"centralized":true,"scopes":["wix-social-blog","ricos"]},
          fedopsConfig: fedopsConfig,
          sentryConfig: sentryConfig,
          persistentAcrossPages: false,
          biLogger: biLogger,
          shouldUseEssentials: true,
          withErrorBoundary: false,
          biConfig: null,
          controllerFileName: "/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/Archive/controller.ts",
          appName: "Wix Blog",
          appDefinitionId: "14bcded7-0066-7c35-14d7-466cb3f09103",
          projectName: "communities-blog-ooi",
          componentName: "Archive",
          localeDistPath: "assets/locales",
          defaultTranslations: defaultTranslations,
          id: "2f3d2c69-2bc4-4519-bd72-0a63dd92577f" }, { method: controller3,
          wrap: wrapController3,
          exports: controllerExport3,
          widgetType: "BLOCKS_WIDGET",
          translationsConfig,
          multilingualDisabled,
          experimentsConfig: {"centralized":true,"scopes":["wix-social-blog","ricos"]},
          fedopsConfig: fedopsConfig,
          sentryConfig: sentryConfig,
          persistentAcrossPages: false,
          biLogger: biLogger,
          shouldUseEssentials: true,
          withErrorBoundary: false,
          biConfig: null,
          controllerFileName: "/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/Below content 1/viewer.controller.ts",
          appName: "Wix Blog",
          appDefinitionId: "14bcded7-0066-7c35-14d7-466cb3f09103",
          projectName: "communities-blog-ooi",
          componentName: "Below content 1",
          localeDistPath: "assets/locales",
          defaultTranslations: defaultTranslations,
          id: "14bcded7-0066-7c35-14d7-466cb3f09103-dqjva" }, { method: controller4,
          wrap: wrapController4,
          exports: controllerExport4,
          widgetType: "BLOCKS_WIDGET",
          translationsConfig,
          multilingualDisabled,
          experimentsConfig: {"centralized":true,"scopes":["wix-social-blog","ricos"]},
          fedopsConfig: fedopsConfig,
          sentryConfig: sentryConfig,
          persistentAcrossPages: false,
          biLogger: biLogger,
          shouldUseEssentials: true,
          withErrorBoundary: false,
          biConfig: null,
          controllerFileName: "/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/Below content 2/viewer.controller.ts",
          appName: "Wix Blog",
          appDefinitionId: "14bcded7-0066-7c35-14d7-466cb3f09103",
          projectName: "communities-blog-ooi",
          componentName: "Below content 2",
          localeDistPath: "assets/locales",
          defaultTranslations: defaultTranslations,
          id: "14bcded7-0066-7c35-14d7-466cb3f09103-bu1xw" }, { method: controller5,
          wrap: wrapController5,
          exports: controllerExport5,
          widgetType: "WIDGET_OUT_OF_IFRAME",
          translationsConfig,
          multilingualDisabled,
          experimentsConfig: {"centralized":true,"scopes":["wix-social-blog","ricos"]},
          fedopsConfig: fedopsConfig,
          sentryConfig: sentryConfig,
          persistentAcrossPages: false,
          biLogger: biLogger,
          shouldUseEssentials: true,
          withErrorBoundary: false,
          biConfig: null,
          controllerFileName: "/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/Blog/controller.ts",
          appName: "Wix Blog",
          appDefinitionId: "14bcded7-0066-7c35-14d7-466cb3f09103",
          projectName: "communities-blog-ooi",
          componentName: "Blog",
          localeDistPath: "assets/locales",
          defaultTranslations: defaultTranslations,
          id: "14c1462a-97f2-9f6a-7bb7-f5541f23caa6" }, { method: controller6,
          wrap: wrapController6,
          exports: controllerExport6,
          widgetType: "BLOCKS_WIDGET",
          translationsConfig,
          multilingualDisabled,
          experimentsConfig: {"centralized":true,"scopes":["wix-social-blog","ricos"]},
          fedopsConfig: fedopsConfig,
          sentryConfig: sentryConfig,
          persistentAcrossPages: false,
          biLogger: biLogger,
          shouldUseEssentials: true,
          withErrorBoundary: false,
          biConfig: null,
          controllerFileName: "/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/Bottom Of Page 1/viewer.controller.ts",
          appName: "Wix Blog",
          appDefinitionId: "14bcded7-0066-7c35-14d7-466cb3f09103",
          projectName: "communities-blog-ooi",
          componentName: "Bottom Of Page 1",
          localeDistPath: "assets/locales",
          defaultTranslations: defaultTranslations,
          id: "14bcded7-0066-7c35-14d7-466cb3f09103-pz2i2" }, { method: controller7,
          wrap: wrapController7,
          exports: controllerExport7,
          widgetType: "BLOCKS_WIDGET",
          translationsConfig,
          multilingualDisabled,
          experimentsConfig: {"centralized":true,"scopes":["wix-social-blog","ricos"]},
          fedopsConfig: fedopsConfig,
          sentryConfig: sentryConfig,
          persistentAcrossPages: false,
          biLogger: biLogger,
          shouldUseEssentials: true,
          withErrorBoundary: false,
          biConfig: null,
          controllerFileName: "/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/Bottom Of Page 2/viewer.controller.ts",
          appName: "Wix Blog",
          appDefinitionId: "14bcded7-0066-7c35-14d7-466cb3f09103",
          projectName: "communities-blog-ooi",
          componentName: "Bottom Of Page 2",
          localeDistPath: "assets/locales",
          defaultTranslations: defaultTranslations,
          id: "14bcded7-0066-7c35-14d7-466cb3f09103-u5w25" }, { method: controller8,
          wrap: wrapController8,
          exports: controllerExport8,
          widgetType: "BLOCKS_WIDGET",
          translationsConfig,
          multilingualDisabled,
          experimentsConfig: {"centralized":true,"scopes":["wix-social-blog","ricos"]},
          fedopsConfig: fedopsConfig,
          sentryConfig: sentryConfig,
          persistentAcrossPages: false,
          biLogger: biLogger,
          shouldUseEssentials: true,
          withErrorBoundary: false,
          biConfig: null,
          controllerFileName: "/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/Bottom of Page 3/viewer.controller.ts",
          appName: "Wix Blog",
          appDefinitionId: "14bcded7-0066-7c35-14d7-466cb3f09103",
          projectName: "communities-blog-ooi",
          componentName: "Bottom of Page 3",
          localeDistPath: "assets/locales",
          defaultTranslations: defaultTranslations,
          id: "14bcded7-0066-7c35-14d7-466cb3f09103-e3jvn" }, { method: controller9,
          wrap: wrapController9,
          exports: controllerExport9,
          widgetType: "WIDGET_OUT_OF_IFRAME",
          translationsConfig,
          multilingualDisabled,
          experimentsConfig: {"centralized":true,"scopes":["wix-social-blog","ricos"]},
          fedopsConfig: fedopsConfig,
          sentryConfig: sentryConfig,
          persistentAcrossPages: false,
          biLogger: biLogger,
          shouldUseEssentials: true,
          withErrorBoundary: false,
          biConfig: null,
          controllerFileName: "/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/CategoryMenu/controller.ts",
          appName: "Wix Blog",
          appDefinitionId: "14bcded7-0066-7c35-14d7-466cb3f09103",
          projectName: "communities-blog-ooi",
          componentName: "CategoryMenu",
          localeDistPath: "components/CategoryMenu/locales",
          defaultTranslations: {"category-link.post-count":"({count, number})","empty-state.no-categories":"No categories yet.","aria-label.category-menu":"Category Menu","category-link.a11y-post-count":"{count, plural, one {# post} other {# posts}}","category-link.a11y-post-count-plural":"{count, number} posts","category-link.a11y-post-count_plural":"{count, number} posts","app-settings.main-tab":"Main","app-settings.display-tab":"Display","app-settings.layout-tab":"Layout","app-settings.design-tab":"Design","app-settings.support-tab":"Support","support-tab.links-divider":"Got a question?","support-tab.read-support-articles-link":"Read Support Articles","support-tab.get-involved-text":"Get involved. Ask questions, get answers and share your thoughts with other bloggers.","support-tab.blog-community-link":"Blog Community","main-tab.title":"Category Menu","main-tab.description":"Display your categories in a menu. Pick a layout, customize the look & more.","main-tab.manage-categories-button":"Manage Categories","main-tab.customize-design-button":"Customize Design","display-tab.show-all-posts-category-label":"Show \"All Posts\"","display-tab.show-post-count-label":"Show number of posts","display-tab.manage-categories-text":"To add and rearrange your categories, go to your Dashboard.","display-tab.manage-categories-button":"Manage Categories","display-tab.mobile.different-settings-label":"Enable mobile settings","tab.mobile.settings-toggle-info-text":"If disabled, your display settings for mobile are taken from desktop. Turn on these settings to customize how your category menu looks on mobile devices.","link-list-design-settings.text-color-label":"Font color","link-list-design-settings.text-font-and-color-label":"Font style & color","link-list-design-settings.background-color-label":"Background opacity & color","link-list-design-settings.separator-color-label":"Divider opacity & color","link-list-design-settings.separator-width-label":"Divider width","link-list-design-settings.border-color-label":"Border opacity & color","link-list-design-settings.border-width-label":"Border width","link-list-design-settings.corner-radius-label":"Corner radius","link-list-design-settings.default-state-tab":"Regular","link-list-design-settings.hover-state-tab":"Hover","link-list-layout-settings.text-alignment-label":"Text alignment","link-list-layout-settings.text-alignment-left":"Left","link-list-layout-settings.text-alignment-center":"Center","link-list-layout-settings.text-alignment-right":"Right","link-list-layout-settings.text-padding-horizontal-label":"Text side padding","link-list-layout-settings.text-padding-vertical-label":"Text top & bottom padding","support-tab.category-menu.about.title":"Customizing a category menu","support-tab.category-menu.about.description":"Categories are a great way to organize and structure your blog. It can also help your readers find the content they want quickly and easily.","support-tab.category-menu.about.read-more":"Read More","support-tab.category-menu.additional-article.creating-categories":"Creating blog categories","support-tab.category-menu.additional-article.deleting-categories":"Deleting blog categories","support-tab.technical-assistant.description":"Technical problems? Troubleshoot common errors and issues.","support-tab.technical-assistant.link-label":"Wix Technical Assistant","support-tab.faq.description":"Find answers in the Blog Community FAQ.","support-tab.faq.link-label":"Frequently Asked Questions","support-tab.customer-care.description":"Still having issues? Contact us for assistance.","support-tab.customer-care.link-label":"Contact Customer Care","support-tab.help-center.label":"Help Center","support-tab.help-center.all-articles":"See All Articles","cssbp.indications-banner-label-cascades":"Changes will cascade to lower breakpoints.","cssbp.indications-banner-desktop&tablet":"Changes apply to desktop and tablet.","cssbp.indications-banner-label-allbreakpoints":"Changes apply to all breakpoints.","cssbp.indications-help":"Learn more"},
          id: "a0d7808c-0d7d-4a40-8cf0-911a9f0de96f" }, { method: controller10,
          wrap: wrapController10,
          exports: controllerExport10,
          widgetType: "WIDGET_OUT_OF_IFRAME",
          translationsConfig,
          multilingualDisabled,
          experimentsConfig: {"centralized":true,"scopes":["wix-social-blog","ricos"]},
          fedopsConfig: fedopsConfig,
          sentryConfig: sentryConfig,
          persistentAcrossPages: false,
          biLogger: biLogger,
          shouldUseEssentials: true,
          withErrorBoundary: false,
          biConfig: null,
          controllerFileName: "/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/MyPosts/controller.ts",
          appName: "Wix Blog",
          appDefinitionId: "14bcded7-0066-7c35-14d7-466cb3f09103",
          projectName: "communities-blog-ooi",
          componentName: "MyPosts",
          localeDistPath: "assets/locales",
          defaultTranslations: defaultTranslations,
          id: "e5a2773b-0e6b-4cbb-a012-3b4a69e92046" }, { method: controller11,
          wrap: wrapController11,
          exports: controllerExport11,
          widgetType: "WIDGET_OUT_OF_IFRAME",
          translationsConfig,
          multilingualDisabled,
          experimentsConfig: {"centralized":true,"scopes":["wix-social-blog","ricos"]},
          fedopsConfig: fedopsConfig,
          sentryConfig: sentryConfig,
          persistentAcrossPages: false,
          biLogger: biLogger,
          shouldUseEssentials: true,
          withErrorBoundary: false,
          biConfig: null,
          controllerFileName: "/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/Post/controller.ts",
          appName: "Wix Blog",
          appDefinitionId: "14bcded7-0066-7c35-14d7-466cb3f09103",
          projectName: "communities-blog-ooi",
          componentName: "Post",
          localeDistPath: "assets/locales",
          defaultTranslations: defaultTranslations,
          id: "211b5287-14e2-4690-bb71-525908938c81" }, { method: controller12,
          wrap: wrapController12,
          exports: controllerExport12,
          widgetType: "BLOCKS_WIDGET",
          translationsConfig,
          multilingualDisabled,
          experimentsConfig: {"centralized":true,"scopes":["wix-social-blog","ricos"]},
          fedopsConfig: fedopsConfig,
          sentryConfig: sentryConfig,
          persistentAcrossPages: false,
          biLogger: biLogger,
          shouldUseEssentials: true,
          withErrorBoundary: false,
          biConfig: null,
          controllerFileName: "/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/Post Categories/viewer.controller.ts",
          appName: "Wix Blog",
          appDefinitionId: "14bcded7-0066-7c35-14d7-466cb3f09103",
          projectName: "communities-blog-ooi",
          componentName: "Post Categories",
          localeDistPath: "assets/locales",
          defaultTranslations: defaultTranslations,
          id: "14bcded7-0066-7c35-14d7-466cb3f09103-pit6d" }, { method: controller13,
          wrap: wrapController13,
          exports: controllerExport13,
          widgetType: "BLOCKS_WIDGET",
          translationsConfig,
          multilingualDisabled,
          experimentsConfig: {"centralized":true,"scopes":["wix-social-blog","ricos"]},
          fedopsConfig: fedopsConfig,
          sentryConfig: sentryConfig,
          persistentAcrossPages: false,
          biLogger: biLogger,
          shouldUseEssentials: true,
          withErrorBoundary: false,
          biConfig: null,
          controllerFileName: "/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/Post Content/viewer.controller.ts",
          appName: "Wix Blog",
          appDefinitionId: "14bcded7-0066-7c35-14d7-466cb3f09103",
          projectName: "communities-blog-ooi",
          componentName: "Post Content",
          localeDistPath: "assets/locales",
          defaultTranslations: defaultTranslations,
          id: "14bcded7-0066-7c35-14d7-466cb3f09103-sw47o" }, { method: controller14,
          wrap: wrapController14,
          exports: controllerExport14,
          widgetType: "BLOCKS_WIDGET",
          translationsConfig,
          multilingualDisabled,
          experimentsConfig: {"centralized":true,"scopes":["wix-social-blog","ricos"]},
          fedopsConfig: fedopsConfig,
          sentryConfig: sentryConfig,
          persistentAcrossPages: false,
          biLogger: biLogger,
          shouldUseEssentials: true,
          withErrorBoundary: false,
          biConfig: null,
          controllerFileName: "/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/Post Counters New/viewer.controller.ts",
          appName: "Wix Blog",
          appDefinitionId: "14bcded7-0066-7c35-14d7-466cb3f09103",
          projectName: "communities-blog-ooi",
          componentName: "Post Counters New",
          localeDistPath: "assets/locales",
          defaultTranslations: defaultTranslations,
          id: "14bcded7-0066-7c35-14d7-466cb3f09103-pzdqd" }, { method: controller15,
          wrap: wrapController15,
          exports: controllerExport15,
          widgetType: "BLOCKS_WIDGET",
          translationsConfig,
          multilingualDisabled,
          experimentsConfig: {"centralized":true,"scopes":["wix-social-blog","ricos"]},
          fedopsConfig: fedopsConfig,
          sentryConfig: sentryConfig,
          persistentAcrossPages: false,
          biLogger: biLogger,
          shouldUseEssentials: true,
          withErrorBoundary: false,
          biConfig: null,
          controllerFileName: "/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/Post Divider/viewer.controller.ts",
          appName: "Wix Blog",
          appDefinitionId: "14bcded7-0066-7c35-14d7-466cb3f09103",
          projectName: "communities-blog-ooi",
          componentName: "Post Divider",
          localeDistPath: "assets/locales",
          defaultTranslations: defaultTranslations,
          id: "14bcded7-0066-7c35-14d7-466cb3f09103-yrjyo" }, { method: controller16,
          wrap: wrapController16,
          exports: controllerExport16,
          widgetType: "BLOCKS_WIDGET",
          translationsConfig,
          multilingualDisabled,
          experimentsConfig: {"centralized":true,"scopes":["wix-social-blog","ricos"]},
          fedopsConfig: fedopsConfig,
          sentryConfig: sentryConfig,
          persistentAcrossPages: false,
          biLogger: biLogger,
          shouldUseEssentials: true,
          withErrorBoundary: false,
          biConfig: null,
          controllerFileName: "/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/Post Footer/viewer.controller.ts",
          appName: "Wix Blog",
          appDefinitionId: "14bcded7-0066-7c35-14d7-466cb3f09103",
          projectName: "communities-blog-ooi",
          componentName: "Post Footer",
          localeDistPath: "assets/locales",
          defaultTranslations: defaultTranslations,
          id: "14bcded7-0066-7c35-14d7-466cb3f09103-h77jn" }, { method: controller17,
          wrap: wrapController17,
          exports: controllerExport17,
          widgetType: "BLOCKS_WIDGET",
          translationsConfig,
          multilingualDisabled,
          experimentsConfig: {"centralized":true,"scopes":["wix-social-blog","ricos"]},
          fedopsConfig: fedopsConfig,
          sentryConfig: sentryConfig,
          persistentAcrossPages: false,
          biLogger: biLogger,
          shouldUseEssentials: true,
          withErrorBoundary: false,
          biConfig: null,
          controllerFileName: "/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/Post Header/viewer.controller.ts",
          appName: "Wix Blog",
          appDefinitionId: "14bcded7-0066-7c35-14d7-466cb3f09103",
          projectName: "communities-blog-ooi",
          componentName: "Post Header",
          localeDistPath: "assets/locales",
          defaultTranslations: defaultTranslations,
          id: "14bcded7-0066-7c35-14d7-466cb3f09103-q8dzf" }, { method: controller18,
          wrap: wrapController18,
          exports: controllerExport18,
          widgetType: "BLOCKS_WIDGET",
          translationsConfig,
          multilingualDisabled,
          experimentsConfig: {"centralized":true,"scopes":["wix-social-blog","ricos"]},
          fedopsConfig: fedopsConfig,
          sentryConfig: sentryConfig,
          persistentAcrossPages: false,
          biLogger: biLogger,
          shouldUseEssentials: true,
          withErrorBoundary: false,
          biConfig: null,
          controllerFileName: "/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/Post Metadata/viewer.controller.ts",
          appName: "Wix Blog",
          appDefinitionId: "14bcded7-0066-7c35-14d7-466cb3f09103",
          projectName: "communities-blog-ooi",
          componentName: "Post Metadata",
          localeDistPath: "assets/locales",
          defaultTranslations: defaultTranslations,
          id: "14bcded7-0066-7c35-14d7-466cb3f09103-wzdp6" }, { method: controller19,
          wrap: wrapController19,
          exports: controllerExport19,
          widgetType: "BLOCKS_WIDGET",
          translationsConfig,
          multilingualDisabled,
          experimentsConfig: {"centralized":true,"scopes":["wix-social-blog","ricos"]},
          fedopsConfig: fedopsConfig,
          sentryConfig: sentryConfig,
          persistentAcrossPages: false,
          biLogger: biLogger,
          shouldUseEssentials: true,
          withErrorBoundary: false,
          biConfig: null,
          controllerFileName: "/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/Post Page/viewer.controller.ts",
          appName: "Wix Blog",
          appDefinitionId: "14bcded7-0066-7c35-14d7-466cb3f09103",
          projectName: "communities-blog-ooi",
          componentName: "Post Page",
          localeDistPath: "assets/locales",
          defaultTranslations: defaultTranslations,
          id: "14bcded7-0066-7c35-14d7-466cb3f09103-ghrxf" }, { method: controller20,
          wrap: wrapController20,
          exports: controllerExport20,
          widgetType: "BLOCKS_WIDGET",
          translationsConfig,
          multilingualDisabled,
          experimentsConfig: {"centralized":true,"scopes":["wix-social-blog","ricos"]},
          fedopsConfig: fedopsConfig,
          sentryConfig: sentryConfig,
          persistentAcrossPages: false,
          biLogger: biLogger,
          shouldUseEssentials: true,
          withErrorBoundary: false,
          biConfig: null,
          controllerFileName: "/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/Post Ratings/viewer.controller.ts",
          appName: "Wix Blog",
          appDefinitionId: "14bcded7-0066-7c35-14d7-466cb3f09103",
          projectName: "communities-blog-ooi",
          componentName: "Post Ratings",
          localeDistPath: "assets/locales",
          defaultTranslations: defaultTranslations,
          id: "14bcded7-0066-7c35-14d7-466cb3f09103-e9hqn" }, { method: controller21,
          wrap: wrapController21,
          exports: controllerExport21,
          widgetType: "BLOCKS_WIDGET",
          translationsConfig,
          multilingualDisabled,
          experimentsConfig: {"centralized":true,"scopes":["wix-social-blog","ricos"]},
          fedopsConfig: fedopsConfig,
          sentryConfig: sentryConfig,
          persistentAcrossPages: false,
          biLogger: biLogger,
          shouldUseEssentials: true,
          withErrorBoundary: false,
          biConfig: null,
          controllerFileName: "/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/Post Share Buttons/viewer.controller.ts",
          appName: "Wix Blog",
          appDefinitionId: "14bcded7-0066-7c35-14d7-466cb3f09103",
          projectName: "communities-blog-ooi",
          componentName: "Post Share Buttons",
          localeDistPath: "assets/locales",
          defaultTranslations: defaultTranslations,
          id: "14bcded7-0066-7c35-14d7-466cb3f09103-y3apm" }, { method: controller22,
          wrap: wrapController22,
          exports: controllerExport22,
          widgetType: "BLOCKS_WIDGET",
          translationsConfig,
          multilingualDisabled,
          experimentsConfig: {"centralized":true,"scopes":["wix-social-blog","ricos"]},
          fedopsConfig: fedopsConfig,
          sentryConfig: sentryConfig,
          persistentAcrossPages: false,
          biLogger: biLogger,
          shouldUseEssentials: true,
          withErrorBoundary: false,
          biConfig: null,
          controllerFileName: "/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/Post Tags/viewer.controller.ts",
          appName: "Wix Blog",
          appDefinitionId: "14bcded7-0066-7c35-14d7-466cb3f09103",
          projectName: "communities-blog-ooi",
          componentName: "Post Tags",
          localeDistPath: "assets/locales",
          defaultTranslations: defaultTranslations,
          id: "14bcded7-0066-7c35-14d7-466cb3f09103-gcv5t" }, { method: controller23,
          wrap: wrapController23,
          exports: controllerExport23,
          widgetType: "BLOCKS_WIDGET",
          translationsConfig,
          multilingualDisabled,
          experimentsConfig: {"centralized":true,"scopes":["wix-social-blog","ricos"]},
          fedopsConfig: fedopsConfig,
          sentryConfig: sentryConfig,
          persistentAcrossPages: false,
          biLogger: biLogger,
          shouldUseEssentials: true,
          withErrorBoundary: false,
          biConfig: null,
          controllerFileName: "/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/Post Title/viewer.controller.ts",
          appName: "Wix Blog",
          appDefinitionId: "14bcded7-0066-7c35-14d7-466cb3f09103",
          projectName: "communities-blog-ooi",
          componentName: "Post Title",
          localeDistPath: "assets/locales",
          defaultTranslations: defaultTranslations,
          id: "14bcded7-0066-7c35-14d7-466cb3f09103-e25z0" }, { method: controller24,
          wrap: wrapController24,
          exports: controllerExport24,
          widgetType: "BLOCKS_WIDGET",
          translationsConfig,
          multilingualDisabled,
          experimentsConfig: {"centralized":true,"scopes":["wix-social-blog","ricos"]},
          fedopsConfig: fedopsConfig,
          sentryConfig: sentryConfig,
          persistentAcrossPages: false,
          biLogger: biLogger,
          shouldUseEssentials: true,
          withErrorBoundary: false,
          biConfig: null,
          controllerFileName: "/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/Post Writer/viewer.controller.ts",
          appName: "Wix Blog",
          appDefinitionId: "14bcded7-0066-7c35-14d7-466cb3f09103",
          projectName: "communities-blog-ooi",
          componentName: "Post Writer",
          localeDistPath: "assets/locales",
          defaultTranslations: defaultTranslations,
          id: "14bcded7-0066-7c35-14d7-466cb3f09103-ak2wd" }, { method: controller25,
          wrap: wrapController25,
          exports: controllerExport25,
          widgetType: "WIDGET_OUT_OF_IFRAME",
          translationsConfig,
          multilingualDisabled,
          experimentsConfig: {"centralized":true,"scopes":["wix-social-blog","ricos"]},
          fedopsConfig: fedopsConfig,
          sentryConfig: sentryConfig,
          persistentAcrossPages: false,
          biLogger: biLogger,
          shouldUseEssentials: true,
          withErrorBoundary: false,
          biConfig: null,
          controllerFileName: "/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/PostList/controller.ts",
          appName: "Wix Blog",
          appDefinitionId: "14bcded7-0066-7c35-14d7-466cb3f09103",
          projectName: "communities-blog-ooi",
          componentName: "PostList",
          localeDistPath: "assets/locales",
          defaultTranslations: defaultTranslations,
          id: "813eb645-c6bd-4870-906d-694f30869fd9" }, { method: controller26,
          wrap: wrapController26,
          exports: controllerExport26,
          widgetType: "WIDGET_OUT_OF_IFRAME",
          translationsConfig,
          multilingualDisabled,
          experimentsConfig: {"centralized":true,"scopes":["wix-social-blog","ricos"]},
          fedopsConfig: fedopsConfig,
          sentryConfig: sentryConfig,
          persistentAcrossPages: false,
          biLogger: biLogger,
          shouldUseEssentials: true,
          withErrorBoundary: false,
          biConfig: null,
          controllerFileName: "/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/RelatedPosts/controller.ts",
          appName: "Wix Blog",
          appDefinitionId: "14bcded7-0066-7c35-14d7-466cb3f09103",
          projectName: "communities-blog-ooi",
          componentName: "RelatedPosts",
          localeDistPath: "assets/locales",
          defaultTranslations: defaultTranslations,
          id: "46a9e991-c1cc-47c9-b19a-e99d3be1e2c9" }, { method: controller27,
          wrap: wrapController27,
          exports: controllerExport27,
          widgetType: "WIDGET_OUT_OF_IFRAME",
          translationsConfig,
          multilingualDisabled,
          experimentsConfig: {"centralized":true,"scopes":["wix-social-blog","ricos"]},
          fedopsConfig: fedopsConfig,
          sentryConfig: sentryConfig,
          persistentAcrossPages: true,
          biLogger: biLogger,
          shouldUseEssentials: true,
          withErrorBoundary: false,
          biConfig: null,
          controllerFileName: "/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/RssButton/controller.ts",
          appName: "Wix Blog",
          appDefinitionId: "14bcded7-0066-7c35-14d7-466cb3f09103",
          projectName: "communities-blog-ooi",
          componentName: "RssButton",
          localeDistPath: "components/RssButton/locales",
          defaultTranslations: {"app-settings.design-tab":"Design","app-settings.main-tab":"Main","app-settings.settings-tab":"Settings","app-settings.support-tab":"Support","design-tab.background-circle":"Circle","design-tab.background-color":"Background color","design-tab.background-none":"None","design-tab.background-square":"Square","design-tab.background-type":"Choose a background","design-tab.icon-color":"Icon color","main-tab.customize-design-button":"Customize Button","main-tab.description":"This button lets visitors subscribe to your blog’s RSS feed.","support-tab.links-divider":"Got a question?","support-tab.about.title":"Connecting your blog to an RSS Feed","support-tab.about.description":"Many people use RSS Readers to stay up-to-date with their favorite blogs.","support-tab.about.read-more":"Read More","support-tab.technical-assistant.description":"Technical problems? Troubleshoot common errors and issues.","support-tab.technical-assistant.link-label":"Wix Technical Assistant","support-tab.faq.description":"Find answers in the Blog Community FAQ.","support-tab.faq.link-label":"Frequently Asked Questions","support-tab.customer-care.description":"Still having issues? Contact us for assistance.","support-tab.customer-care.link-label":"Contact Customer Care","support-tab.help-center.label":"Help Center","support-tab.help-center.all-articles":"See All Articles"},
          id: "1515a9e7-b579-fbbb-43fc-0e3051c14803" }, { method: controller28,
          wrap: wrapController28,
          exports: controllerExport28,
          widgetType: "WIDGET_OUT_OF_IFRAME",
          translationsConfig,
          multilingualDisabled,
          experimentsConfig: {"centralized":true,"scopes":["wix-social-blog","ricos"]},
          fedopsConfig: fedopsConfig,
          sentryConfig: sentryConfig,
          persistentAcrossPages: false,
          biLogger: biLogger,
          shouldUseEssentials: true,
          withErrorBoundary: false,
          biConfig: null,
          controllerFileName: "/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/TagCloud/controller.ts",
          appName: "Wix Blog",
          appDefinitionId: "14bcded7-0066-7c35-14d7-466cb3f09103",
          projectName: "communities-blog-ooi",
          componentName: "TagCloud",
          localeDistPath: "assets/locales",
          defaultTranslations: defaultTranslations,
          id: "c0a125b8-2311-451e-99c5-89b6bba02b22" }, { method: controller29,
          wrap: wrapController29,
          exports: controllerExport29,
          widgetType: "BLOCKS_WIDGET",
          translationsConfig,
          multilingualDisabled,
          experimentsConfig: {"centralized":true,"scopes":["wix-social-blog","ricos"]},
          fedopsConfig: fedopsConfig,
          sentryConfig: sentryConfig,
          persistentAcrossPages: false,
          biLogger: biLogger,
          shouldUseEssentials: true,
          withErrorBoundary: false,
          biConfig: null,
          controllerFileName: "/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/Top of Page/viewer.controller.ts",
          appName: "Wix Blog",
          appDefinitionId: "14bcded7-0066-7c35-14d7-466cb3f09103",
          projectName: "communities-blog-ooi",
          componentName: "Top of Page",
          localeDistPath: "assets/locales",
          defaultTranslations: defaultTranslations,
          id: "14bcded7-0066-7c35-14d7-466cb3f09103-nz8hi" }],
    true);

    export const createControllers = _createControllers
